var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.011,
    height: 27.057,
    viewBox: "0 0 27.011 27.057",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxl-instagram-alt",
    transform: "translate(-4.495 -4.47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1",
    "data-name": "Caminho 1",
    d: "M31.42,12.457a9.8,9.8,0,0,0-.628-3.324,6.915,6.915,0,0,0-3.95-3.95,9.909,9.909,0,0,0-3.279-.63C22.12,4.488,21.663,4.47,18,4.47s-4.133,0-5.565.083a9.909,9.909,0,0,0-3.277.63,6.911,6.911,0,0,0-3.95,3.95,9.831,9.831,0,0,0-.628,3.277c-.065,1.444-.084,1.9-.084,5.565s0,4.131.084,5.565a9.887,9.887,0,0,0,.628,3.28,6.915,6.915,0,0,0,3.951,3.948,9.876,9.876,0,0,0,3.277.675c1.444.065,1.9.084,5.565.084s4.133,0,5.565-.084a9.885,9.885,0,0,0,3.279-.628,6.923,6.923,0,0,0,3.95-3.95,9.852,9.852,0,0,0,.628-3.28c.065-1.443.084-1.9.084-5.565s0-4.128-.087-5.564ZM17.991,24.9a6.934,6.934,0,1,1,6.934-6.934A6.932,6.932,0,0,1,17.991,24.9ZM25.2,12.394a1.617,1.617,0,1,1,1.615-1.617A1.615,1.615,0,0,1,25.2,12.394Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2",
    "data-name": "Caminho 2",
    d: "M22.5,17.968a4.5,4.5,0,1,1-4.5-4.505,4.5,4.5,0,0,1,4.5,4.505Z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaIcon);
export default __webpack_public_path__ + "static/media/insta_icon.ea666fa7c5c1004ad8abdd6cad0ec904.svg";
export { ForwardRef as ReactComponent };